import { trpc } from '@/shared/api/trpc';

const useInvalidateOrg = () => {
  const utils = trpc.useUtils();
  return (id: string) => {
    utils.organizations.findOne.invalidate({ id });
    utils.auth.me.invalidate();
  };
};

/**
 * Generate a new Optigest per-org API key. The raw key is in the mutation
 * result and must be shown to the operator immediately — it is never
 * retrievable again.
 */
export const useGenerateOptigestKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.generateOptigestKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

export const useRevokeOptigestKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.revokeOptigestKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};
